import React, { useState, useEffect, useRef } from "react";
import "./App.css";


// the dictionary  
const marvelWords = {

easy: [ { w: "IRONMAN", d: "Genius, billionaire, playboy, philanthrophist" },
 { w: "THOR", d: "God of Thunder" },
{ w: "HULK", d: "A scientist with anger issues" },
{ w: "CAPTAINAMERICA", d: "A patriotic hero" },
{ w: "SPIDERMAN", d: "Friendly neighbourhood _" },
{ w: "BLACKWIDOW", d: "A deadly spy with a mysterious past" },
{ w: "HAWKEYE", d: "A master archer" },
{ w: "DOCTORSTRANGE", d: "The Master of the Mystic Arts" },
{ w: "WANDA", d: "A powerful sorceress with chaos magic" },
{ w: "VISION", d: "A synthezoid" },],

medium: [ { w: "PEPPER", d: "Iron Man's love interest" },
{ w: "ASGARD", d: "Thor's home planet" },
{ w: "CHEESEBURGER", d: "Tony Stark's ( and Morgan's :( ) favourite food ) " },
{ w: "HYDRA", d: "A Nazi-fascist terrorist organization that seeks world domination" },
{ w: "VULTURE", d: "Main Villain of Spider-Man: Homecoming named after a bird" },
{ w: "MBAKU", d: "Leader of the Jabaris" },
{ w: "SHAWARMA", d: "The Avengers went to eat _ after the Battle of New York" },
{ w: "HULKBUSTER", d: "Suit of armor made by Tony and Bruce to defeat the Hulk" },
{ w: "MANTIS", d: "A guardian named after a bug" },
{ w: "MJOLNIR", d: "Thor's hammer's name" },],    

hard: [ { w: "VORMIR", d: "The location of the Soul Stone" },
{ w: "TESSERACT", d: "The container for the Space Stone" },
{ w: "QUANTUM", d: "the _ Realm is a microscopic universe where the laws of space and time don't apply" },
{ w: "LAUFEY", d: "Who is Loki's real father, the leader of the Frost Giants?" },
{ w: "NEUROSURGEON", d: "What kind of doctor was Doctor Strange?" },
{ w: "FRIDAY", d: "The assistant system that replaced JARVIS in Age of Ultron" },
{ w: "CHITAURI", d: "The alien race who invaded New York in The Avengers" },
{ w: "LEVITATION", d: "Doctor Strange wears the Cloak of _" },
{ w: "REDWING", d: "Falcon's electronic bird's name" },
{ w: "RONIN", d: "The alias Clint Barton adopts after the Blip" },],
};
  
// random word picker 
const pickWord = (diff, usedWords) => {
    const availableWords = marvelWords[diff].filter(wordObj => !usedWords.includes(wordObj.w));
    if (availableWords.length === 0) {
        return null; 
    }

    const randomIndex = Math.floor(Math.random() * availableWords.length);
    return availableWords[randomIndex]; 
};

// game states and variables
const Game = ({ user, setUser }) => {
    const typedGuessRef = useRef("");
    const [word, setWord] = useState(null);
    const [msg, setMsg] = useState("");
    const [chosen, setChosen] = useState("");
    const [hints, setHints] = useState(3);
    const [wrong, setWrong] = useState(0);
    const [history, setHistory] = useState([]);
    const [diff, setDiff] = useState("easy");
    const [gameStarted, setGameStarted] = useState(false);
    const [usedWords, setUsedWords] = useState({ easy: [], medium: [], hard: [] });
    const [givenUp, setGivenUp] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [typedGuess, setTypedGuess] = useState("");
    const inputRef = useRef(null);
    const [showDifficulty, setShowDifficulty] = useState(false);
    const [timeLeft, setTimeLeft] = useState(300);
    const [score, setScore] = useState(0);
    const [streak, setStreak] = useState(0);
    const [bestStreak, setBestStreak] = useState(0);
    const [showInstructions, setShowInstructions] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
const [gameOver, setGameOver] = useState(false);
const toggleDifficultyModal = () => {
    setShowDifficulty(prev => !prev);
};
const setDifficulty = (level) => {
    setDiff(level);
    setShowDifficulty(false); 
    restartGame();
};

// timer
useEffect(() => {
    let interval;
    if (!showInstructions && !showLogin && !gameOver) { 
        interval = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    alert("Time's up! (╥ᆺ╥;) Game Over!");
                    setGameOver(true);
                    endGame(false);
                    
                    setTimeout(() => {
                        restartGame();
                    }, 2000);

                    return 0; 
                }
                return prev - 1;
            });
        }, 1000);
    }
    return () => clearInterval(interval);
}, [showInstructions, showLogin, gameOver]);

    
//restart
const restartGame = () => {
    setScore(0); // Reset score on restart
    setTimeLeft(300);
    setGameOver(false);
    setShowInstructions(false);
    setShowLogin(false);
    setStreak(0);
    setUsedWords({ easy: [], medium: [], hard: [] }); 

    const nextWord = pickWord(diff, []);
    if (nextWord) {
        setWord(nextWord);
        setMsg("");
        setChosen("");
        setHints(3);
        setWrong(0);
        setGameStarted(false);
        setTimeout(() => setGameStarted(true), 100);
        setGivenUp(false);
    } else {
        alert(`You've finished all the words for ${diff} difficulty! Choose another or restart the game`);
        setGameStarted(false);
    }
};

    
// letters 


useEffect(() => {
    if (wrong > 0) {
        setMsg("Try Again! (╥ᆺ╥;)");
        setTimeout(() => {
            setMsg(""); 
        }, 2000);
    }
}, [wrong]);

    // too many wrong guesses
    useEffect(() => {
        if (word && wrong >= 3) { 
            alert("Game Over!  (╥ᆺ╥;)");
            endGame(false);
        }
    }, [wrong, word]);

// keyboard letters synced
useEffect(() => {
    const handleKeyDown = (event) => {
        if (!gameStarted || !word || gameOver) return;  
        const key = event.key.toUpperCase();
        if (/^[A-Z]$/.test(key) && !chosen.includes(key)) {
            setTypedGuess(prev => prev + key);
            selectLetter(key);
        }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
}, [gameStarted, chosen, word, gameOver]);

    
// correct guess  
    useEffect(() => {
        if (!gameStarted || !word) return;
        if (typedGuess === word.w) {
            setMsg("Correct! ٩(ˊᗜˋ*)و");
            setTimeout(() => {
                endGame(true);
            }, 1000);
        }
    }, [typedGuess, gameStarted, word]);

  // end game : update words, history and streak     
    const endGame = (win) => {
        if (word) {
            const updatedUsedWords = { ...usedWords };
            updatedUsedWords[diff].push(word.w);
            setUsedWords(updatedUsedWords);
    
            const newHistoryEntry = { word: word.w, won: win, difficulty: diff };
            setHistory((prevHistory) => [...prevHistory, newHistoryEntry]);
    
            if (win) {
                setScore(prevScore => prevScore + 10); 
                setStreak(prevStreak => {
                    const newStreak = prevStreak + 1;
                    if (newStreak > bestStreak) {
                        setBestStreak(newStreak);
                    }
                    return newStreak;
                });
            } else {
                setStreak(0);
            }
            
   //  next round
            const nextWord = pickWord(diff, updatedUsedWords[diff]);
            if (nextWord) {
                setWord(nextWord);
                setMsg("");
                setChosen("");
                setHints(3);
                setWrong(0);
                setGameStarted(true);
                setGivenUp(false);
            } else {
                alert(`You've finished all the words for ${diff} difficulty!`);
                setGameStarted(false);
            }
        }
    };

    // history modal
    const toggleHistoryModal = () => {
        setShowHistoryModal(!showHistoryModal);
    };
    
    // hints
    const giveHint = () => {
        if (hints > 0 && word) {
            const revealedLetter = word.w.split("").find(l => !chosen.includes(l));
            if (revealedLetter) selectLetter(revealedLetter);
            setHints(hints - 1);
        }
    };

    // check answer
        const guess = () => {
            if (!word) return;
        
            const win = word.w.split("").every(letter => chosen.includes(letter));
            if (win) {
                setMsg("Correct! ٩(ˊᗜˋ*)و");
                setScore(prevScore => prevScore + 10);
                setTimeout(() => {
                    endGame(true);
                    setMsg("");
                }, 2000);
            } else {
                setMsg("Try Again! (╥ᆺ╥;)");
            }
        };
        

    
// update difficulty 
useEffect(() => {
    const initialWord = pickWord(diff, usedWords[diff]); 
    if (initialWord) {
        setWord(initialWord);
        setMsg("");
        setChosen("");
        setHints(3);
        setWrong(0);
        setGameStarted(true);
        setGivenUp(false);
    } else {
        alert(`You've finished all the words for ${diff} difficulty!`);
        setGameStarted(false);
    }
}, [diff]);

const changeDiff = (e) => {
    setDiff(e.target.value); 
};
// letters
const selectLetter = (letter) => {
    if (!gameStarted || chosen.includes(letter) || !word) return;
    
    setChosen((prev) => prev + letter);

    if (!word.w.includes(letter)) {
        setWrong((prev) => prev + 1); 
    }
};

const showLetters = () => (
    <div className="letter-selection">
        {Array.from({ length: 26 }).map((_, i) => {
            const l = String.fromCharCode(65 + i);
            return (
                <button
                    key={l}
                    onClick={() => selectLetter(l)}
                    disabled={chosen.includes(l) || !gameStarted}
                    className={`letter-button ${chosen.includes(l) ? "selected" : ""}`}
                >
                    {l}
                </button>
            );
        })}
    </div>
);

// words box
    const letterBoxes = () => {
        if (!gameStarted || !word) {
            return null;
        }
        return (
            <div className="word-container">
                {word.w.split("").map((letter, index) => (
                    <div key={index} className={`letter ${chosen.includes(letter) ? "visible" : ""}`}>
                        {chosen.includes(letter) ? letter : ""}
                    </div>
                ))}
            </div>
        );
    };

    // disable guess button when not needed
    const isGuessDisabled = !word || word.w.split("").some(letter => !chosen.includes(letter));

    // give up
    const handleGiveUp = () => {
        if (!word) return;
    
        setGivenUp(true);
        setMsg(`You gave up! The word was: ${word.w}`);
    
        setScore(prevScore => Math.max(0, prevScore - 10)); 
    
        setTimeout(() => {
            endGame(false);
            setMsg("");
        }, 2000);
    };
    

// display 
    return (
        <div className="container">
            <div className="top-navbar">
                <button onClick={toggleHistoryModal} className="nav-button"> 🗐 History</button>
                <button onClick={() => setShowInstructions(true)} className="nav-button"> ⓘ How to Play</button>
                <button onClick={toggleDifficultyModal} className="nav-button"> 𖤉 Difficulty</button>
            </div>
            <div className="stats-navbar">
                <div className="stat-item">★ Score: <span>{score}</span></div>
                <div className="stat-item"> ✪ Streak: <span>{streak}</span></div>
                <div className="stat-item"> ♛ Best Streak: <span>{bestStreak}</span></div>
                <div className="stat-item">⏱︎  Time Left: <span className={timeLeft <= 10 ? "low-time" : ""}>{timeLeft}s</span></div>
            </div>
    <h1> Marvel Word Guess Game</h1>
            {letterBoxes()}
            <p className="word-description"> Hint: {word && word.d}</p>
            <div className="button-section">
                
            <div className="game-buttons">
    <button onClick={restartGame} className="restart-button" disabled={!gameStarted}>Restart</button>
        
    <div className="hint-container">
        <span className="hint-counter">Hints: {hints}</span>
        <button onClick={giveHint} disabled={hints === 0 || !gameStarted} className="hint-button">Hint</button>
    </div>
</div>

<div className="letter-selection">{showLetters()}</div>

                <div className="gngbtns">
                <button onClick={guess} disabled={isGuessDisabled} className="guess-button">Guess</button>
                <button onClick={handleGiveUp} disabled={!gameStarted} className="give-up-button">Give Up</button>
                </div>
            </div>
            {msg === "Correct! ٩(ˊᗜˋ*)و" && <p className="correct-message">{msg}</p>}
            {msg && msg !== "Correct! ٩(ˊᗜˋ*)و" && <p className="wrong-message">{msg}</p>}

            {showInstructions && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h2>How to Play Marvel Word Guess 🕷 </h2>
<h3> Objective ➴</h3> 
<p>
Guess the hidden Marvel-related word before time runs out! 
</p>
<h3> Game Rules ✮ </h3>
<p>
You have 5 minutes to guess the words in each difficulty. <br /> 
Click on letters to guess. Correct guesses fill in the blanks. <br /> 
Use hints if you're stuck. <br /> 
Click Give Up to reveal the answer and start a new round. <br /> 
</p>
<h3> ♛ Winning & Losing  </h3>
<p>
✔ Win: Guess the word correctly to earn points and extend your streak. <br /> 
✖ Lose: Run out of time, and your streak resets! 
</p>
<h3> ⚡︎ Tips </h3> 
<p>
Start with common letters (A, E, R, S, T). <br /> 
Think of Marvel heroes, villains, locations, and items. <br /> 
Use hints wisely!
</p>
                        <button onClick={() => setShowInstructions(false)}>Got it!</button>
                    </div>
                </div>
            )}
  {showDifficulty && (
    <div className="modal-overlay">
        <div className="modal">
            <h2>Select Difficulty</h2>
            <button className="difficulty-option" onClick={() => setDifficulty('easy')}>Easy</button>
            <button className="difficulty-option" onClick={() => setDifficulty('medium')}>Medium</button>
            <button className="difficulty-option" onClick={() => setDifficulty('hard')}>Hard</button>
            <button onClick={toggleDifficultyModal}>Close</button>
        </div>
    </div>
)}

            {showHistoryModal && (
                <div className="history-modal">
                    <div className="history-modal-content">
                        <h2>Game History</h2>
                        <div className="history">
                            {history.length === 0 ? <p>No guesses yet</p> : history.map((item, index) => (
                                <p key={index}>{item.word} - {item.won ? "Won" : "Lost"} ({item.difficulty})</p>
                            ))}
                        </div>
                        <button onClick={toggleHistoryModal}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );    
};
export default Game;